import { api } from '../../api/client'
import { createCdnMedia, FANSLY_CDN } from './cdnMedia'
import { createCrmClient } from './crmClient'

/** The console session's CRM client: React CRM pages share this one instance. */
export const crmClient = createCrmClient({
  getToken: () => api.getToken(),
  refreshToken: () => api.refreshAccessToken(),
})

/** OnlyFans media for React CRM pages; one queue and cache for the whole console. */
export const crmMedia = createCdnMedia({ post: crmClient.post })

/** Fansly media (same rules: IP-locked signatures go through the CRM), its own queue and cache. */
export const fanslyMedia = createCdnMedia({ post: crmClient.post, cdn: FANSLY_CDN })

export { CrmError } from './crmClient'
export type { CdnSource, CdnMedia } from './cdnMedia'
export { createPager, type Page, type Pager } from './pager'
